import axios from "axios";
import authHeader from "./auth-header";
import { normalizeUrl } from "@/utils/urlUtils";

const API_URL = process.env.VUE_APP_API_URL;

class GoogleMapsService {
  fetchCities(query) {
    const url = normalizeUrl(API_URL, "/google-maps/cities");
    return axios.get(url, {
      params: { query },
      headers: authHeader(),
    });
  }

  fetchLocationDetails(lat, lng) {
    const url = normalizeUrl(API_URL, "/google-maps/location-details");
    return axios.get(url, {
      params: { latlng: `${lat},${lng}` },
      headers: authHeader(),
    });
  }

   /**
   * NEW: Fetch place details using Google Place ID
   */
  fetchPlaceDetails(placeId) {
    const url = normalizeUrl(API_URL, "/google-maps/place-details");
    return axios.get(url, {
      params: { place_id: placeId },
      headers: authHeader(),
    });
  }

  /**
   * NEW: Batch fetch multiple place details for better performance
   */
  batchFetchPlaceDetails(placeIds) {
    const url = normalizeUrl(API_URL, "/google-maps/batch-place-details");
    return axios.post(url, {
      place_ids: placeIds
    }, {
      headers: authHeader(),
    });
  }
}

export default new GoogleMapsService();